const ageValidationVisibility = (type = 'id_card') => {

  const elms = document.querySelectorAll('[data-age-validation-type]');
  if(elms) {
    elms.forEach(elm => {
      if(elm.dataset.ageValidationType === type) {
        elm.style.display = ''
      } else {
        elm.style.display = 'none';
      }
    });
  }

}

const ageValidation = () => {


  const ageValidationType = document.querySelector('[data-age-validation="selection"]');

  if(ageValidationType) {
    let currentValidationType = ageValidationType.value;
    ageValidationVisibility(currentValidationType);

    ageValidationType.addEventListener('change', (e) => {
      currentValidationType = e.target.value;
      ageValidationVisibility(currentValidationType);
    });

  }

}

ageValidation()
